import React from 'react'

import ReactPaginate from 'react-paginate'

import { CONFIG_BASE_URL, SETTINGS_PAGINATION } from 'utils/consts'

import arrowLeft from 'assets/images/arrow-left.svg'
import arrowRight from 'assets/images/arrow-right.svg'

export default class Pagination extends React.Component {
  static defaultProps = {
    isHideControls: false,
    forcePage: 1,
  }

  state = {
    itemsPerPage: SETTINGS_PAGINATION.COUNT_PER_PAGE,
    pageNumber: SETTINGS_PAGINATION.PAGE_NUMBER,
  }

  /**
   * @param {Object} event
   */
  onChangeSelect = event => {
    this.props.changePagination(
      +event.target.value,
      SETTINGS_PAGINATION.PAGE_NUMBER,
      this.props.searchQuery
    )
    this.setState({ itemsPerPage: +event.target.value })
  }

  /**
   * @param {Object} number
   */
  onClickPageNumber = number => {
    const pageNumber = number.selected + 1
    this.props.changePagination(
      this.state.itemsPerPage,
      pageNumber,
      this.props.searchQuery
    )
  }

  render() {
    const { items, pageCount, forcePage, isHideControls } = this.props
    const { itemsPerPage } = this.state

    return (
      <div
        className={`bottom-controls${
          isHideControls ? ' bottom-controls--center' : ''
        }`}>
        {!isHideControls && (
          <>
            <div className='show'>
              Показывать:
              <select onChange={this.onChangeSelect} value={itemsPerPage}>
                <option value='50'>50</option>
                <option value='40'>40</option>
                <option value='30'>30</option>
                <option value='20'>20</option>
                <option value='10'>10</option>
              </select>
            </div>
            <div className='find'>Найдено: {items.length}</div>
          </>
        )}

        {pageCount > 1 && (
          <ReactPaginate
            forcePage={forcePage - 1}
            containerClassName='pagination'
            disabledClassName='disabled'
            previousLabel={
              <img
                src={CONFIG_BASE_URL + arrowLeft}
                alt='Переход к предыдущей странице'
                title='Предыдущая страница'
              />
            }
            nextLabel={
              <img
                src={CONFIG_BASE_URL + arrowRight}
                alt='Переход к следующей странице'
                title='Следующая страница'
              />
            }
            pageRangeDisplayed={1}
            marginPagesDisplayed={3}
            pageCount={pageCount}
            onPageChange={this.onClickPageNumber}
          />
        )}
      </div>
    )
  }
}
